/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const FlagRegularV6 = (props) => (
  <Icon {...props} name="Flag Regular V6">
    <path d="M14.884 0c-.199 0-.407.042-.604.132-1.428.652-2.486.873-3.369.873-1.874 0-2.963-.996-5.122-.996-1.082 0-2.433.25-4.287 1.002V.75A.75.75 0 0 0 0 .75v14.5a.749.749 0 1 0 1.5 0V12c1.675-.746 3.001-.994 4.15-.994 2.301 0 3.903.993 6.206.993.997 0 2.126-.187 3.472-.722.425-.156.672-.515.672-.899V.96c0-.613-.522-.96-1.116-.96zM14.5 9.994c-.947.338-1.815.503-2.644.503-.963 0-1.822-.219-2.733-.45-1-.254-2.134-.543-3.472-.543-1.323 0-2.687.284-4.15.867V2.63l.563-.228c1.481-.6 2.699-.892 3.725-.892.882 0 1.535.21 2.291.452.793.255 1.692.543 2.831.543 1.107 0 2.258-.265 3.591-.832v8.32H14.5z" />
  </Icon>
);

export default FlagRegularV6;
